var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ 'node-trigger', _vm.item.classes ],on:{"click":_vm.click}},[(_vm.item.source)?_c('img',{attrs:{"src":_vm.item.source,"alt":"..."}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }